import { ReportDownloadDetail } from '../interfaces/ReportDownloadDetail';
import { ReportDetails } from './../../../app/services/api/generated';
import { ReportType } from './../../../enums/ReportType';
import { ReportStatus } from '../../../enums/ReportStatus';

export const setFriendlyName = (name: string): string => {
  const nameRelationships = [
    { name: ReportType.ActualVsTheory, match: ['theory_vs_actual_', 'TheoryActualReport'] },
    { name: ReportType.StockOnHand, match: ['stock_on_hand_', 'StockOnHandReport'] },
    { name: ReportType.Waste, match: ['waste_', 'WasteReport'] },
    { name: ReportType.ItemActivity, match: ['item_activity_', 'ItemActivityReport'] },
    { name: ReportType.Transfers, match: ['transfers_', 'TransferReport'] },
    { name: ReportType.ExtendedStockCount, match: ['extended_stock_count_', 'ExtendedStockCountReport'] },
    { name: ReportType.StockCount, match: ['stock_count_', 'StockCountReport'] },
    { name: ReportType.ItemTimeout, match: ['item_time_out_', 'ItemTimeOutReport'] },
    { name: ReportType.CostOfSales, match: ['cost_of_sales_', 'CostOfSalesReport'] },
    { name: ReportType.StockDays, match: ['stock_days_', 'StockDaysReport'] },
    { name: ReportType.Invoice, match: ['InvoiceReconciliation_', 'InvoiceRecReport'] },
    { name: ReportType.StockCountSummary, match: ['stockcountsummary_', 'StockCountSummaryReport'] },
    { name: ReportType.Margin, match: ['margin_', 'ProductMarginReport'] },
    { name: ReportType.EgActualVsTheory, match: ['EGTheoryActualReport_', 'EuroGaragesTheoryActualReport'] },
    { name: ReportType.EgWaste, match: ['EGWasteReport_', 'EuroGaragesWasteReport'] },
    { name: ReportType.EgCostOfSales, match: ['EGCostOfSalesReport_', 'EuroGaragesCostOfSalesReport'] },
    { name: ReportType.EgItemActivity, match: ['EGItemActivityReport_', 'EuroGaragesItemActivityReport'] },
    { name: ReportType.EgItemTimeout, match: ['EGItemTimeOutReport_', 'EuroGaragesItemTimeOutReport'] },
    { name: ReportType.EgStockDays, match: ['EGStockDaysReport_', 'EuroGaragesStockDaysReport'] },
    { name: ReportType.EgStockOnHand, match: ['EGStockOnHandReport_', 'EuroGaragesStockOnHandReport'] },
    { name: ReportType.EgTransfers, match: ['EGTransferReport_', 'EuroGaragesTransferReport'] },
    { name: ReportType.CreditPurchase, match: ['creditpurchase_', 'CreditPurchaseReport'] },
    { name: ReportType.StockCountVsUsage, match: ['Stock_Counts_Vs_Usage_', 'StockCountsVsUsageReport'] },
    { name: ReportType.DcShortage, match: ['dc_shortage_', 'DcShortageReport'] },
    { name: ReportType.ConstrainedItem, match: ['constraineditem_', 'ConstrainedItemReport'] },
    { name: ReportType.ItemStockOut, match: ['item_stock_out_', 'ItemStockOutReport'] },
    { name: ReportType.Receipt, match: ['receipts_', 'ReceiptsReport'] },
    { name: ReportType.MadeInStore, match: ['made_in_store_', 'MadeInStoreReport'] },
    { name: ReportType.Cogs, match: ['cogs_', 'CogsReport'] },
    { name: ReportType.SalesCheck, match: ['checks_', 'CheckReport'] },
    { name: ReportType.ItemUsage, match: ['item_usage', 'ItemUsageReport'] },
    { name: ReportType.ReturnablePackaging, match: ['returnable_packaging', 'ReturnablePackagingReport'] },
  ];
  
  for (const nameRel of nameRelationships) {
    for (const pattern of nameRel.match) {
      if (name.includes(pattern)) {
        return nameRel.name;
      }
    }
  }
  return name;
};
  
export const prepareReports = (reports: ReportDetails[]) => {
  const expandedReports: ReportDownloadDetail[] = [];
  
  for (const report of reports) {
    let from = '';
    let to = '';
  
    if (!report.name) {
      continue;
    }
  
    const name = setFriendlyName(report.name);
    const splitName = report.name.split('_');
    if (splitName[splitName.length - 1] === 'report') {
      if (report.name.includes('theory_vs_actual_') ||
          report.name.includes('waste_') ||
          report.name.includes('item_activity_') ||
          report.name.includes('transfers_') ||
          report.name.includes('item_time_out_') ||
          report.name.includes('margin_') ||
          report.name.includes('InvoiceReconciliation_') ||
          report.name.includes('EGTheoryActualReport_') ||
          report.name.includes('EGWasteReport_') ||
          report.name.includes('EGCostOfSalesReport_') ||
          report.name.includes('EGItemActivityReport_') ||
          report.name.includes('EGItemTimeOutReport_') ||
          report.name.includes('EGStockDaysReport_') ||
          report.name.includes('EGStockOnHandReport_') ||
          report.name.includes('EGTransferReport_') ||
          report.name.includes('creditpurchase_') ||
          report.name.includes('Stock_Counts_Vs_Usage_') ||
          report.name.includes('constraineditem_') ||
          report.name.includes('item_stock_out_') ||
          report.name.includes('receipts_') ||
          report.name.includes('made_in_store_') ||
          report.name.includes('checks_') ||
          report.name.includes('cogs_') ||
          report.name.includes('item_usage') ||
          report.name.includes('returnable_packaging')
      ) {
        from = buildDateString(splitName[splitName.length - 3]);
        to = buildDateString(splitName[splitName.length - 2]);
      }
    }
  
    expandedReports.push({
      id: report.id,
      name: report.name,
      displayName: name,
      createdAt: report.createdAt,
      dateFrom: from,
      dateTo: to,
      storeNumber: report.starbucksStoreNumber,
      storeName: report.storeName,
      status: report.status ?? ReportStatus.Completed,
    });
  }
  
  return expandedReports;
};

const buildDateString = (rawDate: string): string => {
  if (rawDate.length === 6) {
    const breakdown = rawDate.match(/.{1,2}/g);
    
    //MM/DD/YY
    return breakdown ?  `${breakdown[1]}/${breakdown[2]}/${breakdown[0]}` : '';
  }

  return '';
};